<template>
  <nav class="level app-levelbar">
    <div class="level-left">
      <div class="level-item">
        <h3 class="subtitle is-5">
          <strong>{{ label }}</strong>
        </h3>
      </div>
    </div>
    <div class="level-right is-hidden-mobile">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="item in list"
          :key="item.path"
          :to="{ path: item.path }"
        >
          {{ item.meta.label }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </nav>
</template>

<script>
export default {
    components: {},

    data() {
        return {
            list: null
        }
    },

    created() {
        this.getList()
    },

    computed: {
        label() {
            return this.$route.meta.label || this.$route.name
        }
    },

    methods: {
        getList() {
            let matched = this.$route.matched
            let first = matched[0]
            if (first && (first.name !== '登录' && first.name !== '首页')) {
                matched = [{ meta: { label: '首页' }, path: '/home' }].concat(matched)
            }
            this.list = matched
        }
    },

    watch: {
        $route() {
            this.getList()
        }
    }
}
</script>



// WEBPACK FOOTER //
// Levelbar.vue?7a6669e4